import { getPlatform } from '@/shared/utils/config';
const platform = getPlatform();

export const AppHeader = defineAsyncComponent(() =>
  import(`./ui/${platform}/index.vue`).then(m => m.default),
);
